<template>
  <div>
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="问题描述：" prop="desc">
          <el-input
            type="textarea"
            placeholder="请尽可能详细的描述您遇到的问题"
            v-model.trim="ruleForm.desc"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 上传按钮 -->
      <el-upload
        class="upload-demo"
        action=""
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        :on-change="uploadPreview"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button size="small" @click="uploadBtn">
          <i class="iconfont icon-daochu"></i>上传附件
        </el-button>
        <!-- <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，且不超过500kb
        </div> -->
        <div slot="tip" class="el-upload__tip">
          支持类型： (仅支持JPG、GIF、PNG文件，且小于200k)
        </div>
      </el-upload>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="toHome">返回</el-button>
        <el-button
          type="success"
          class="submit_btn"
          :loading="sundflag"
          @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </div>
      <!-- 验证为空的弹窗 -->
      <div class="delete_view">
        <el-dialog title="温馨提示" :visible.sync="promptTextarea">
          <div class="delete_mian">
            <p>问题描述不能为空！</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              @click="promptTextarea = false"
              sundflag="false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
      <div class="delete_view">
        <el-dialog title="温馨提示" :visible.sync="messageFully">
          <div class="delete_mian">
            <p>留言成功</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="refresh" sundflag="false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import qs from "qs";
import { questionFeedback } from "@/api/examination.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      promptTextarea: false,
      messageFully: false,
      sundflag: false, // 防抖
      ruleForm: {
        desc: "",
      },
      rules: {
        desc: [{ required: true, message: "请填写问题描述", trigger: "blur" }],
      },
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
      url: "",
      type: "",
    };
  },
  methods: {
    submitForm(formName) {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Feedback:save",
          parent_code: "PersonalCenter:Feedback",
        },
        "statetime"
      );
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Feedback:back",
          parent_code: "PersonalCenter:Feedback",
        },
        "statetime"
      );
      this.$router.push("/papers");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList, "已移出文件的钩子");
    },
    handlePreview(file) {
      console.log(file, "已上传的钩子触发");
    },
    handleExceed(files, fileList) {
      this.$message.warning("当前只能上传一个文件");
      console.log(files, "这是文件夹数量拦截");
      console.log(fileList, "这是文件夹数量拦截222");
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleAvatarSuccess(res, file) {
      // 将上面渲染图片格式修改成服务器需要的编码格式
      // let reader = new FileReader();
      // reader.readAsDataURL(res.imgUrl);
    },
    refresh() {
      this.messageFully = false;
      location.reload();
    },
    uploadPreview(file, filelist) {
      // console.log(file);
      // console.log(filelist);
      // console.log(file.raw.type, "上传前的拦截");
      // // 204800
      const isJPG = file.raw.type === "image/jpeg";
      const isGIF = file.raw.type === "image/gif";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.size;
      if (!isJPG && !isGIF && !isPNG) {
        this.$message.error("上传图片只能是 JPG、GIF、PNG文件，且小于200k!");
        this.fileList = [];
      }
      if (isLt2M > 204800) {
        this.$message.error("上传图片大小不能超过 200KB!");
        this.fileList = [];
      }
      this.type = file.raw.type.split("/")[1];

      console.log(this.type, "文件后缀");
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        //完全读取好文件的回调。
        console.log(e); //完全成功之后的的回调。
        this.url = reader.result.replace(/^data:image\/\w+;base64,/, ""); //然后直接替换在url里面。
      };
      return isJPG && isLt2M;
      // if (file.size >204800) {
      //  this.$message.warning("当前文件大于200KB");
      //   return false; //必须返回false
      // }
    },
    // 保存上传
    async saveData() {
      if (this.ruleForm.desc === "" || this.ruleForm.desc === null) {
        this.promptTextarea = true;
      }
      this.sundflag = true;
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        Content: this.ruleForm.desc,
        FileSuffix: this.type,
        Img: this.url,
      };
      const Data = await questionFeedback(qs.stringify(params));
      if (Data.status === 200) {
        //  this.$message({
        //   message: "恭喜你，上传成功",
        //   type: "success",
        // });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.messageFully = true;
      } else {
        this.sundflag = false;
        this.$message.error("上传失败");
      }
    },
    // 上传附件埋点
    uploadBtn() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Feedback:upload",
          parent_code: "PersonalCenter:Feedback",
        },
        "statetime"
      );
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
.el-card {
  border: none;
}
::v-deep .el-card__body {
  padding: 44px 24px;
}
.el-form {
  margin-top: 64px;
}
::v-deep .el-textarea__inner {
  width: 609px;
  height: 260px;
}
::v-deep .upload-demo {
  margin: 33px 0 0 100px;
  .el-button {
    background: #ffffff;
    color: #333333;
    width: 168px;
    height: 50px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
    span > i {
      font-size: 16px !important;
      margin-right: 28px;
      font-weight: bold;
    }
  }
}
.operation {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
// 弹窗
::v-deep .el-dialog {
  width: 300px;
  height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 14px;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-upload__tip {
  font-size: 14px;
  color: #bbbbbb;
}
::v-deep .el-upload-list {
  width: 355px;
  li {
    display: flex;
    align-items: center;
    height: 40px;
  }
}
::v-deep .el-upload-list__item-status-label {
  top: 8px !important;
}
::v-deep .el-textarea {
  width: 609px;
}
</style>